import LuggageSelect from './LuggageSelect'

export default LuggageSelect
